// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"0a173020","133":"f0c18703","182":"3ada148a","919":"cc56ade2"}[chunkId] + ".chunk.js";
};